import { Country } from "@utils/constants/localisation";
import { IMSTokenParams, getWithIDToken } from "@utils/http/MSAuthAPI";

export interface IAvailableVehicleParams {
    hub?: string,
    vehicle_type: string,
}

export interface IVehicleSpecs {
    body_type: string
}

// This interface corresponds to the FleetioVehicle dataclass (not model!) on the backend
export interface IVehicle {
    id: string
    make: string
    model: string
    year: string
    color: string
    license_plate: string
    vin: string
    current_meter_value: number
    noticeGiven?: string
    specs: IVehicleSpecs
    group_name: string | null
    group_ancestry: string | null
    reserved_for: string | null  // If present - is a CRM ID the vehicle is reserved for
}

export interface IAvailableQuotedVehicleParams {
    hub: string;
    vehicle_type: string;
    make: string;
    model: string;
    year: number;
}


interface IVehicleService {
    getAvailableVehicles(qParams: IAvailableVehicleParams, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]>,
    getVehicleStatuses(filter: string, country: Country, IDTokenParams: IMSTokenParams): Promise<any[]>,
    getVehicleById(vehicleId: string, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]>,
    getAvailableQuotedVehicles(qParams: IAvailableQuotedVehicleParams, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]>,
}



export const VehicleService: IVehicleService = {
    async getAvailableVehicles(qParams: IAvailableVehicleParams, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]> {
        const resp = await getWithIDToken(
            '/v1/vehicles/available',
            IDTokenParams,
            { ...qParams, country }
        );
        console.debug("Available vehicles fetched:", {country, data: resp.data});
        return resp.data;
    },
    async getVehicleStatuses(filter: string, country: Country, IDTokenParams: IMSTokenParams): Promise<any[]> {
        const resp = await getWithIDToken(
            '/v1/vehicles/statuses',
            IDTokenParams,
            { filter, country }
        );
        console.debug("Vehicle statuses fetched:", {data: resp.data, country});
        return resp.data;
    },
    async getVehicleById(vehicleId: string, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]> {
        const resp = await getWithIDToken(
            `/v1/vehicles/${vehicleId}`,
            IDTokenParams,
            { country: country }
        );
        console.debug("Vehicle details fetched:", {data: resp.data, vehicleId, country});
        return resp.data;
    },
    async getAvailableQuotedVehicles(qParams: IAvailableVehicleParams, country: Country, IDTokenParams: IMSTokenParams): Promise<IVehicle[]> {
        const resp = await getWithIDToken(
            "/v1/vehicles/quoted",
            IDTokenParams,
            { ...qParams, country }
        );
        console.debug("Available quoted vehicles fetched:", { country, data: resp.data });
        return resp.data;
    },
};